module.exports = __webpack_public_path__ + "static/media/loading-indicator.9f0bb82a.gif";